import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/gtm';

/**
 * Hook to automatically track page views on route changes
 */
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Small delay to ensure page title is updated
    const timeoutId = setTimeout(() => {
      trackPageView(location.pathname + location.search);
    }, 0);

    return () => clearTimeout(timeoutId);
  }, [location.pathname, location.search]);
};
